import { render, staticRenderFns } from "./OrdersInboundEditAdmin.vue?vue&type=template&id=29263f4d&scoped=true"
import script from "./OrdersInboundEditAdmin.vue?vue&type=script&lang=js"
export * from "./OrdersInboundEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29263f4d",
  null
  
)

export default component.exports